import { BaseError } from "../BaseError";

export const DIFFICULTY = {
  BEGINNER: 1,
  NORMAL: 2,
  HYPER: 3,
  ANOTHER: 4,
  LEGGENDARIA: 5,
} as const;

export type Difficulty = (typeof DIFFICULTY)[keyof typeof DIFFICULTY];

export const DIFFICULTY_STRING = {
  1: "BEGINNER",
  2: "NORMAL",
  3: "HYPER",
  4: "ANOTHER",
  5: "LEGGENDARIA",
} as const;

export const isDifficulty = (n: unknown): n is Difficulty => {
  return typeof n === "number" && Object.values<typeof n>(DIFFICULTY).includes(n);
};

export const parseDifficulty = (n: number): Difficulty => {
  if (isDifficulty(n)) {
    return n;
  }
  throw new ParseDifficultyError("Difficultyに変換できません");
};

export class ParseDifficultyError extends BaseError {}

export const DIFFICULTY_CRITERIA = {
  ...DIFFICULTY,
  MOST_DIFFICULT: 9,
} as const;

export type DifficultyCriteria = (typeof DIFFICULTY_CRITERIA)[keyof typeof DIFFICULTY_CRITERIA];

export const DIFFICULTY_CRITERIA_STRING = {
  ...DIFFICULTY_STRING,
  9: "最上位",
} as const;

export const isDifficultyCriteria = (n: unknown): n is DifficultyCriteria => {
  return typeof n === "number" && Object.values<typeof n>(DIFFICULTY_CRITERIA).includes(n);
};

export const parseDifficultyCriteria = (n: number): DifficultyCriteria => {
  if (isDifficultyCriteria(n)) {
    return n;
  }
  throw new ParseDifficultyCriteriaError("DifficultyCriteriaに変換できません");
};

export class ParseDifficultyCriteriaError extends BaseError {}
